export default {
  mySetting_nickName:'昵称：',
  mySetting_switch_home:'切换首页',
}
